// extracted by mini-css-extract-plugin
export default {"innerWrapper":"wy-z","tooltipWrapper":"xy-z","icon":"yy-z","tooltip":"zy-z","content":"Ay-z"};